import styled from "styled-components";

export const filterX = "7px";
export const filterRight = "14px";
export const filterBottom = "10px";

export const filterMargins = `
  margin-right: ${filterRight};
  margin-bottom: ${filterBottom};
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  max-width: ${props => (props.mobileView ? "100%" : "97%")};
`;

export const Inner = styled.div`
  max-height: ${props => `${props.heightBreakPoint}px`};
  overflow: hidden;
  transition: all 0.3s ease-out;
  background: ${props => props.theme.backgroundDark};
  border-radius: ${props => (props.mobileView ? "0" : "10px")};
  padding: 0 34px 0 ${props => (props.mobileView ? "24px" : "12px")};
  position: relative;
  width: 100%;

  .more-icon-container {
    position: absolute;
    top: -12px;
    right: ${props => (props.mobileView ? "36px" : "0")};
    height: ${props => props.heightBreakPoint}px;
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: 5;
  }

  ${props =>
    props.containerHeight > props.heightBreakPoint &&
    props.showMore &&
    ` 
      max-height: 80vh;
      padding-bottom: 12px;
      overflow-y: hidden;
`}

  ${props =>
    props.mobileView &&
    props.containerHeight > props.heightBreakPoint &&
    props.showMore &&
    `    
      max-height: 1000px;
      overflow-y: visible;
  `}

  /* Soft fade at the bottom edge to hint there are more filters below.
     z-index keeps it above the chips (which use z-index up to 3). */
  ${props =>
    props.containerHeight > props.heightBreakPoint &&
    !props.showMore &&
    `
      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 28px;
        z-index: 4;
        pointer-events: none;
        background: linear-gradient(
          to bottom,
          transparent,
          ${props.theme.backgroundDark}
        );
      }
  `}

  ::-webkit-scrollbar {
    width: 8px;
    opacity: 0;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    opacity: 0;
    width: 15px;
    background-color: ${props => props.theme.backgroundDark};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.06);
    opacity: 0.6;
    border-radius: 2px;
  }

  .selected-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .filter {
      ${filterMargins};
    }

    .this-is-an-aggregate-filter {
      padding: 0 ${filterX};
      margin-right: 0 !important;
      background-color: ${({ mobileView, theme }) =>
        mobileView ? theme.backgroundDark : theme.backgroundLight};
    }

    .last-filter {
      border-radius: 0 16px 16px 0;
      //Might want back in. But I think it makes it hard to tell where the ending agg filter is... padding-right: 0;
      margin-right: ${filterRight} !important;
      padding: 0 ${filterRight} 0 ${filterX};
    }
  }

  .aggregates-container {
    display: flex;
    align-items: center;
    height: 26px;
    border-radius: 12px;

    @media (max-width: 800px) {
      height: unset;
    }

    .selected-tags {
      margin-top: 18px;
    }

    .aggregate-tag {
      margin-right: 10px;
    }
  }
  .is-aggregate {
    background: ${props => props.theme.backgroundLight};
  }
`;

export const Button = styled.div`
  background: ${props => props.theme.highlight};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${props => props.theme.p4b.ff};
  font-size: ${props => props.theme.p4b.fs};
  color: ${props => props.theme.white};
  border-radius: ${props => props.theme.br.lg};
  line-height: 10px;
  cursor: pointer;

  .icon {
    margin-right: 8px;
    margin-bottom: 3px;
  }
`;
